import ConfiguratorRoutes from '../enums/ConfiguratorRoutes';
import { PriceTypes } from '../enums/PriceTypes';
export const extractPrices = ({ prices, priceDisplay, platformFeatures, group, isSummaryTotalPrice, }) => {
    const defaultPrice = {
        money: {
            amount: 0,
            currency: '',
        },
        type: '',
    };
    let isPrimaryPrice;
    let isSecondaryPrice;
    const isModelsPage = location.pathname.includes(ConfiguratorRoutes.MODELS);
    const isVariantsPage = location.pathname.includes(ConfiguratorRoutes.TRIM_LEVELS);
    const shouldShowBasePriceOnModelsOrVariantsPage = priceDisplay.showBasePriceOnModelsAndVariantsPage &&
        (isModelsPage || isVariantsPage);
    const { carTypeWithIva } = platformFeatures || {};
    const isDisplayPriceByType = priceDisplay.displayPriceByType;
    const isMatchingCarType = carTypeWithIva && group?.includes(carTypeWithIva);
    if (isDisplayPriceByType) {
        isPrimaryPrice = price => shouldShowBasePriceOnModelsOrVariantsPage ||
            (isMatchingCarType && !isSummaryTotalPrice)
            ? price.type === PriceTypes.NET_PRICE
            : price.type === priceDisplay.primary.priceType;
        isSecondaryPrice = price => price.type === priceDisplay?.secondary?.priceType;
    }
    else {
        isPrimaryPrice = price => price?.money?.currency === priceDisplay.primary.currency;
        isSecondaryPrice = price => price?.money?.currency === priceDisplay?.secondary?.currency;
    }
    const getPrimaryPrice = (prices) => {
        if (prices?.length) {
            return prices?.find(price => isPrimaryPrice(price));
        }
    };
    const getSecondaryPrice = (prices) => {
        if (prices?.length) {
            return prices?.find(price => isSecondaryPrice(price));
        }
    };
    const primaryPrice = getPrimaryPrice(prices) ?? defaultPrice;
    const secondaryPrice = getSecondaryPrice(prices) ?? defaultPrice;
    return { primaryPrice, secondaryPrice };
};
//# sourceMappingURL=extractPrices.js.map